"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getSigninUrl = _interopRequireDefault(require("./getSigninUrl"));
var _default = exports.default = function _default(baseUrl) {
  var queryString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  window.location.href = "".concat((0, _getSigninUrl.default)(baseUrl)).concat(queryString);
};